import React, { useState, useEffect, useContext, useRef } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import SideMenu from "./student/SideMenu";

import tmdbApi from "../api/tmdbApi";
import axios from 'axios';
import moment from "moment";
import Editor from 'react-simple-wysiwyg';
import Select, { components } from 'react-select';
import Loader from "../components/loader";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuid } from 'uuid';
import { Uploader } from "../utils/upload"
import SessionPopup from "./SessionPopup"
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import OpenSeadragon from "openseadragon";
import parse from "react-html-parser";

// import "./../../src/assets/caseFeedback.css";
let { lambda, country, appname } = window.app;


const CaseFeedback = () => {

    let { id, caseid } = useParams();
    const navigate = useNavigate();

    const [feedBackListData, setFeedBackListData] = useState(null);
    const [selectedFeedbacks, setSelectedFeedbacks] = useState([]);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [showDeleteAllConfirm, setShowDeleteAllConfirm] = useState(false);
    const [deletingFeedbackId, setDeletingFeedbackId] = useState(null);
    const [feedbacksToDelete, setFeedbacksToDelete] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    const { route, setRoute, setCurrentPage: setContextCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);


    const getFeedbackAPI = async () => {
        try {
            const response = await tmdbApi.getFeedbackApi(caseid, id, "admin");
            if (response?.result) {
                console.log('kiiiirann', response?.result, "---")
                setFeedBackListData(response?.result?.[0])
            }
        } catch {
            console.log("error");
        }
    };
    const isHtml = (str = "") => /<\/?[a-z][\s\S]*>/i.test(str);

    const stripHtml = (html = "") => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };


    console.log('feedbacksToDelete', feedbacksToDelete)
    const deleteFeedbackAPI = async (feedbackIds) => {
        console.log('ddddddddddddddddddddd', feedbackIds)
        try {
            setIsDeleting(true);

            // Create the body in the exact format required
            const requestBody = {
                feedbackIds: feedbackIds
            };

            console.log('Deleting feedbacks with body:', JSON.stringify(requestBody));

            const response = await tmdbApi.deleteFeedback(id, caseid, requestBody);

            if (response?.success || response?.result) {
                toast.success(feedbackIds.length > 1 ? 'Feedbacks deleted successfully' : 'Feedback deleted successfully');
                await getFeedbackAPI();
                setSelectedFeedbacks([]);
                setFeedbacksToDelete([]);
                setDeletingFeedbackId(null);
                setCurrentPage(1); // Reset to first page after deletion
            } else {
                toast.error('Failed to delete feedback');
            }
        } catch (error) {
            console.log("error deleting feedback", error);
            toast.error('Error deleting feedback');
        } finally {
            setIsDeleting(false);
            setShowDeleteConfirm(false);
            setShowDeleteAllConfirm(false);
        }
    };

    const handleCheckboxChange = (feedbackId) => {
        setSelectedFeedbacks(prev => {
            if (prev.includes(feedbackId)) {
                return prev.filter(id => id !== feedbackId);
            } else {
                return [...prev, feedbackId];
            }
        });
    };

    const handleSingleDelete = (feedbackId) => {
        setDeletingFeedbackId(feedbackId);
        setFeedbacksToDelete([feedbackId]);
        setShowDeleteConfirm(true);
    };

    const handleDeleteAll = () => {
        if (selectedFeedbacks.length === 0) {
            toast.warning('Please select at least one feedback to delete');
            return;
        }
        setFeedbacksToDelete([...selectedFeedbacks]);
        setShowDeleteAllConfirm(true);
    };

    const confirmSingleDelete = () => {
        if (feedbacksToDelete.length > 0) {
            deleteFeedbackAPI(feedbacksToDelete);
            setShowDeleteConfirm(false)
        }
    };

    const confirmDeleteAll = () => {
        if (feedbacksToDelete.length > 0) {
            deleteFeedbackAPI(feedbacksToDelete);
            setShowDeleteAllConfirm(false)
        }
    };

    const cancelDelete = () => {
        setShowDeleteConfirm(false);
        setShowDeleteAllConfirm(false);
        setDeletingFeedbackId(null);
        setFeedbacksToDelete([]);
    };

    useEffect(() => {
        if (!localStorage.getItem("token")) navigate("/");
        getFeedbackAPI();
    }, []);

    const handleBack = (e) => {
        GetTimeActivity()
        navigate("/feedbacks")
    }

    // Get filtered feedbacks (excluding archived)
    const filteredFeedbacks = feedBackListData?.users?.filter(item => item.status !== "ARCHIVE") || [];

    // Calculate pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentFeedbacks = filteredFeedbacks.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredFeedbacks.length / itemsPerPage);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        // Scroll to top of feedback list
        document.querySelector('.feedback-list')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <>
            <div id="layout-wrapper">
                <Header />
                <SideMenu />

                <div className="main-content user-management create-user edit-module-page" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">{feedBackListData?.modulename}</h4>
                                            <p className="menu-path" id="breadcrumb-path">
                                                <span>Feedback</span> / <b id="breadcrumb-action">Case Feedback</b>
                                            </p>
                                        </div>
                                        <div>
                                            <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">back
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="create-user-block" id="create-user-block">
                                {feedBackListData?.users?.length > 0 ? (
                                    <>
                                        <div className="form-block" id="form-block">

                                            <div className="case-info-section">
                                                <h6>Case Details:</h6>
                                                <h5 className="feedback-case-name mt-3">{feedBackListData?.casename}</h5>
                                                {/* <p className="case-description">{feedBackListData?.clinicalhistory}</p> */}
                                                <p className="case-description" dangerouslySetInnerHTML={{ __html: feedBackListData?.clinicalhistory }} />

                                            </div>
                                            <div className="feedbacks-section d-flex justify-content-between align-items-center mt-3">
                                                <b className="feedback-section-title">
                                                    Feedbacks{" "}
                                                    {selectedFeedbacks.length > 0 && (
                                                        <> ( {selectedFeedbacks.length} <span className="feedback-btn-text">Selected</span> ) </>
                                                    )}

                                                </b>
                                                <div className="feedbcak-btns d-flex gap-1">
                                                    <a id="button" target="_blank" onClick={() => { navigate('/EditModulecase/' + caseid + "/" + id) }} className="stroke-btn-style edit-btn create-quiz-btn d-flex justify-content-center 
                                                    align-items-center gap-1">
                                                        <span className="feedback-icon material-symbols-outlined">
                                                            edit
                                                        </span><span className="feedback-btn-text">Edit case</span>
                                                    </a>

                                                    <a id="button" target="_blank" onClick={() => { navigate('/editcase/' + caseid) }} className="stroke-btn-style master-btn create-quiz-btn d-flex justify-content-center 
                                                    align-items-center gap-1">
                                                        <span className="material-symbols-outlined feedback-icon">
                                                            open_in_browser
                                                        </span><span className="feedback-btn-text">Master case</span>
                                                    </a>
                                                    <a
                                                        id="delete-all-button"
                                                        onClick={handleDeleteAll}
                                                        className="stroke-btn-style delete-all-button create-quiz-btn d-flex justify-content-center 
                                                    align-items-center gap-1"
                                                        style={{
                                                            cursor: selectedFeedbacks.length === 0 ? 'not-allowed' : 'pointer',
                                                            opacity: selectedFeedbacks.length === 0 ? 0.5 : 1
                                                        }}
                                                    ><span className="feedback-icon material-symbols-outlined">
                                                            delete
                                                        </span>
                                                        <span className="feedback-btn-text">{isDeleting ? 'Deleting...' : 'Delete Selected'}</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="feedback-list">
                                                {currentFeedbacks.map((item, index) => (
                                                    <div className="feedback" key={index}>
                                                        <div className="feedback-header d-flex justify-content-between align-items-center">
                                                            <h6 className="feedback-user-name d-flex justify-content-between align-items-center gap-2">

                                                                {item?.username}
                                                            </h6>
                                                            <span className="feedback-date ms-2">
                                                                {new Date(item.created).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                                                            </span>
                                                        </div>

                                                        <div className="feedback-msg mt-2">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedFeedbacks.includes(item?.feedbackid)}
                                                                onChange={() => handleCheckboxChange(item?.feedbackid)}
                                                                disabled={isDeleting}
                                                            />
                                                            <div className="feedback-description mt-1">
                                                                {item?.feedbackDescription ? (
                                                                    isHtml(item.feedbackDescription) ? (
                                                                        <div className="html-content">
                                                                            {parse(item.feedbackDescription)}
                                                                        </div>
                                                                    ) : (
                                                                        <span>{item.feedbackDescription}</span>
                                                                    )
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </div>

                                                            {/* {item?.feedbackDescription} */}
                                                        </div>

                                                        <div className="feedback-delete-btn d-flex justify-content-end">
                                                            <a
                                                                id={`delete-feedback-${index}`}
                                                                onClick={() => handleSingleDelete(item?.feedbackid)}
                                                                style={{ cursor: isDeleting ? 'not-allowed' : 'pointer' }}
                                                            >
                                                                {isDeleting && deletingFeedbackId === item?.feedbackid ? 'Deleting...' : 'Delete'}
                                                            </a>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Pagination Controls */}
                                            {/* {filteredFeedbacks.length > itemsPerPage && (
                                                <div className="case-feedback-pagination pagination-wrapper d-flex justify-content-end align-items-center gap-2 mt-4">
                                                       <span className="pagination-info ms-3">
                                                         {currentPage}-{totalPages} of {filteredFeedbacks.length} 
                                                    </span>
                                                    <button
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                        className="pagination-btn"
                                                        style={{
                                                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                                            opacity: currentPage === 1 ? 0.5 : 1
                                                        }}
                                                    >
                                                        <span className="material-symbols-outlined">chevron_left</span>
                                                    </button>

                                                    <div className="pagination-numbers d-flex gap-1">
                                                        {[...Array(totalPages)].map((_, idx) => (
                                                            <button
                                                                key={idx + 1}
                                                                onClick={() => handlePageChange(idx + 1)}
                                                                className={`pagination-number ${currentPage === idx + 1 ? 'active' : ''}`}
                                                            >
                                                                {idx + 1}
                                                            </button>
                                                        ))}
                                                    </div>

                                                    <button
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                        className="pagination-btn"
                                                        style={{
                                                            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                                            opacity: currentPage === totalPages ? 0.5 : 1
                                                        }}
                                                    >
                                                        <span className="material-symbols-outlined">chevron_right</span>
                                                    </button>

                                                 
                                                </div>
                                            )} */}
                                        </div>
                                    </>
                                ) : (
                                    <div className="form-block" id="loading-block">
                                        <div className="tab-content p-3 text-muted">
                                            <div className="tab-pane active show" id="home1" role="tabpanel">
                                                <div className="row">
                                                    <Loader />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <Footer id="footer" />
                </div>
            </div>


            <SweetAlert
                show={showDeleteConfirm}
                warning
                showCancel
                confirmBtnText="Yes, delete it!"
                confirmBtnBsStyle="danger"
                title="Are you sure?"
                onConfirm={confirmSingleDelete}
                onCancel={cancelDelete}
                focusCancelBtn
                disabled={isDeleting}
            >
                You want to delete this feedback?
            </SweetAlert>

            <SweetAlert
                show={showDeleteAllConfirm}
                warning
                showCancel
                confirmBtnText={
                    feedbacksToDelete.length === 1
                        ? "Yes, delete it!"
                        : "Yes, delete them!"
                }
                confirmBtnBsStyle="danger"
                title="Are you sure?"
                onConfirm={confirmDeleteAll}
                onCancel={cancelDelete}
                focusCancelBtn
                disabled={isDeleting}
            >
                You want to delete {feedbacksToDelete.length} selected feedback
                {feedbacksToDelete.length === 1 ? "?" : "s?"}
            </SweetAlert>

            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
        </>
    );
};

export default CaseFeedback;